<template>
  <div class="pb-3" >
    <va-card :title="$t(`chatBlock.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-select
                  :label="$t('chatBlock.headings.name')"
                  v-model="client"
                  textBy="name"
                  searchable
                  :placeholder="$t('chatBlock.forms.name')"
                  :noOptionsText="$t('chatBlock.forms.noName')"
                  maxHeight='200px'
                  :error="errors.length > 0"
                  :messages="errors"
                  :options="clients.length > 0 ? clients : []"
                />
              </ValidationProvider>
              <ValidationProvider name="Data Inicio" v-slot="{ errors }">
                <va-date-picker
                  :label="$t('chatBlock.headings.expiredDate')"
                  :placeholder="$t('chatBlock.forms.expiredDate')"
                  :config="{enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true}"
                  :error="errors.length > 0"
                  :messages="errors"
                  v-model="chatBlock.datetime"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="chatBlock.message"
                  :label="$t('chatBlock.headings.message')"
                  :placeholder="$t('chatBlock.forms.message')"
                  :success="errors.length == 0 && chatBlock.message.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'ChatBlockAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      chatBlock: {
        clientId: '',
        message: '',
        datetime: '',
      },
      client: '',
      clients: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  apollo: {
    clients: {
      query: gql`
      query myquery {
        clients: client(order_by: {id: asc}, where: {contracted_plans: {active: {_eq: true}}}) {
          id
          fullName
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          const clients = data.clients.map(client => {
            return { ...client, name: `${client.id} - ${client.fullName}` }
          })
          this.clients = clients
          if (clients.length > 0 && this.client === '') {
            this.client = Object.assign({}, clients[0])
          }
        }
      },
    },
  },
  mounted () {
    this.client = ''
    this.chatBlock.clientId = ''
    this.chatBlock.message = ''
    this.chatBlock.datetime = ''
    if (this.updateData !== null) {
      this.chat_block_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.chat_block_get(this.updateData)
      } else {
        this.client = ''
        this.chatBlock.clientId = ''
        this.chatBlock.message = ''
        this.chatBlock.datetime = ''
      }
    },
    client (value) {
      if (value !== '') {
        this.chatBlock.clientId = value.id
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    chat_block_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'client_id') {
            this.chatBlock.clientId = data[value]
          } else if (value === 'expire_date') {
            this.chatBlock.datetime = data[value]
          } else if (value === 'message') {
            this.chatBlock.message = data[value]
          } else if (value === 'client') {
            this.client = data[value]
          } else {
            this.chatBlock[value] = data[value]
          }
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')

      const { clientId, message, datetime } = this.chatBlock
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
              mutation MyMutation($datetime: timestamp, $message: String!, $clientId: Int!, $id: Int!) {
                update_block_chat_by_pk(pk_columns: {id: $id}, _set: {expire_date: $datetime, client_id: $clientId, message: $message}) {
                  id
                }
              }
              ` : gql`
              mutation MyMutation($datetime: timestamp, $message: String!, $clientId: Int!) {
                insert_block_chat(objects: {expire_date: $datetime, client_id: $clientId, message: $message}) {
                  affected_rows
                }
              }
              `
          ),
          variables: this.updateData !== null ? {
            datetime: datetime || null,
            clientId: clientId,
            message: message,
            id: this.chatBlock.id,
          } : {
            datetime: datetime || null,
            clientId: clientId,
            message: message,
          },
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.client = ''
          self.chatBlock.message = ''
          self.chatBlock.datetime = ''
          self.chatBlock.clientId = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.chatBlock.message = ''
          self.chatBlock.datetime = ''
          self.chatBlock.clientId = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
</style>
